const getDisabledClass = (buttonClass='', disableTemporarily=false, disablePermanently=false) => {
    let classDisabled = ''

    if(disablePermanently)  {
        classDisabled = 'disabled-permanently'
    }  else if(disableTemporarily) {
        classDisabled = 'disabled-temporarily'
    }

    if(buttonClass && classDisabled) {
        return buttonClass + ' ' + classDisabled
    } else if(classDisabled)  {
        return classDisabled
    } else {
        return buttonClass
    }
}

export default getDisabledClass